import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  generalData = {
    cx_nombre:'',
    cx_apellido_p:'',
    cx_apellido_m:'',
    cx_correo:'',
    cx_pais:'MX',
    int_telefono:'',
    cx_folio:0,
    proveedor:''
  };


  private nameSource = new BehaviorSubject('');
  currentName = this.nameSource.asObservable();

  private fileIDFrontSource = new BehaviorSubject('');
  fileIDFront = this.fileIDFrontSource.asObservable();

  private fileIDBackSource = new BehaviorSubject('');
  fileIDBack = this.fileIDBackSource.asObservable();

  private fileProofSource = new BehaviorSubject('');
  fileProofAddress = this.fileProofSource.asObservable();

  constructor() {}

  set fromValue(value:string){
    if(sessionStorage.getItem('from')){
      
    } else {
      sessionStorage.setItem('from',value)
    }
  }

  get fromValue():string{
    const from = sessionStorage.getItem('from') || '';
    return from;
  }

  updateName(txt: string) {
    const name = txt.split(' ');
    this.nameSource.next(name[0]);
  }

  updateFileIDFront(file: any) {
    this.fileIDFrontSource.next(file);
  }

  updateFileIDBack(file: any) {
    this.fileIDBackSource.next(file);
  }

  updateFileProofAddress(file: any) {
    this.fileProofSource.next(file);
  }

  setStep(step):void {
    sessionStorage.removeItem('step');
    sessionStorage.setItem('step', step);
  }

  getStep():string {
    let step:string='';
    if( sessionStorage.getItem('step') ) {
      step = String( sessionStorage.getItem('step') );
      return step;
    } else {
      return '';
    }        
  }
  
}
